export enum ECustomerInactivityStepSlug {
  EDIT = 'edit-inactivity',
  INFO = 'info-inactivity'
}

export enum ECustomerInactivityTabs {
  MOBILE_APP = 'mobile-app',
  ONLINE_WIDGET = 'online-widget'
}

export type CustomerInactivityEvent = {
  type: string;
  params?: any;
};
export interface ICustomerInactivityFormData {
  slug: string;
  value: any;
}
export interface ICustomerInactivityStep {
  title: string;
  component: string;
}

export interface ICustomerInactivityInfoTab {
  label: string;
  list: string[];
  observation?: string;
}
